import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import { Router, Route, Link } from 'react-router'

import Azimuth from './react/Azimuth'
import Graph from './react/Graph'

import './style/polaris.less'
import './style/sunitrope.less'

import 'reactjs-spinner/dist/reactjs-spinner.css'
import ReactSpinner from 'reactjs-spinner';

import * as quark from './quark'

// import google_logo from './assets/google.svg'

// import Baobab from 'baobab'
// global.Baobab = Baobab

// var tree = new Baobab({hello: 'world'}, {
//     asynchronous: false
// });
// global.tree = tree;

// tree.on('update', e => {
//     globalUpdate()
// })

global.quark = quark
global.get = quark.get
global.enlist = quark.enlist
global.dofocus = '__root__'

global.graphView = false;

// global.globalUpdate = (() => {})
// global.globalUpdate = e => e // noop until aphelion is loaded


{
    let slash = "\\/"
    let notslash = "[^\\/]+"

    // slash notslash slash public-(read|edit)[0-0a-f]{16} slash notslash+
    let pattern = "^"
        + slash
        + "(public-(read|edit)-[0-9a-f]{16})"
        + "(" + slash + notslash + ")?"
        + "$"

    let magic = RegExp(pattern)
    let res = location.pathname.match(magic)

    // console.log(res, magic)
    if(res){
        quark.loadingFromLink = true
        quark.access_key = res[1]
        console.log('access_key', quark.access_key)
    } 
    quark.canEdit = !res || (res[2] == 'edit');

    pattern = '^'
        + slash
        + '(' + notslash + ')'
        + "(" + slash + notslash + ")?"
        + "$"
    
    magic = RegExp(pattern)
    res = location.pathname.match(magic)

    if(res){
        quark.path = res[1]
    } else {
        quark.path = 'default'
        history.replaceState({}, "", '/' + quark.path)
    }

}
const INIT_MAX_ENTITIES = 300
window.MAX_ENTITIES = 300

const num_entities = _.throttle(
    e => Object.values(entities)
        .filter(e => Date.now() - e.created < 1000 * 60 * 60 * 24 * 30), 
    500
)


if(!global.$$root$$){
    global.$$root$$ = {"id":"__root__","type":"search","text":""};
}



// let last_upgrade_dismiss = 0
// class AphelionPaid extends Component {
//     constructor(){

//         super()

//         global.globalUpdate = () => {
//             this.setState({})
//         }

//         this.state = {
//             upgradeNagging: false, 
//             signedIn: false
//         }

//         if(quark.loadingFromLink){
//             quark.core.store.createWebSocket()
//         }else{
//             gapi.load('auth2', e => {
//                 global.auth = gapi.auth2.init({
//                     client_id: '709759612096-dodoa2hrdhr1ufjt8pqo79udb7r2hhmq.apps.googleusercontent.com'
//                 })

//                 // ReactDOM.render(<Aphelion />, document.getElementById('root'));
             
//                 // if(quark.loadingFromLink){
//                 //     quark.core.store.createWebSocket()
//                 // } // otherwise, let aphelion handle opening the socket on login

//                 this.setState({
//                     signedIn: auth.isSignedIn.get()
//                 })

//                 auth.isSignedIn.listen(signedIn => {
//                     // make a websocket if we just signed in
//                     if(signedIn && !global.socket){
//                         quark.core.store.createWebSocket()
//                     }

//                     this.setState({ signedIn })
//                     document.cookie = "signedIn=" + signedIn
//                 })

//             })
//         }
        

//         setInterval(() => {
//             if(num_entities() > MAX_ENTITIES 
//                 && $$root$$.type != 'upgrade'
//                 && Date.now() - last_upgrade_dismiss > 5000){
//                 this.setState({upgradeNagging: true})
//             }
//         }, 5000)

//     }
//     render() {
//         document.body.classList.toggle('dark-theme', !!localStorage.dark)

//         let {signedIn} = this.state
        
//         function HeaderChrome(){
//             return <div className='chrome'>
//                 <div className='spacer'/>
//                 { MAX_ENTITIES > INIT_MAX_ENTITIES 
//                     ? null
//                     : <div onClick={e => {
//                         quark.set_root_text(tok('Upgrade'))
//                         dismissUpgradeNag()
//                     }}>Get More Space</div>
//                 }
//                 <Help />
//                 <div onClick={e => !signedIn
//                         ? auth.signIn()
//                         : auth.signOut()
//                 }>{
//                     !signedIn
//                         ? 'Login'
//                         : 'Logout'
//                 }</div>
//             </div>
//         }

//         // if not logged in and not loading from link
//         if(!signedIn && !quark.loadingFromLink){
//             // show login page
//             return <div className='tachyon nag hidden'
//                 ref={e => setTimeout(() => e ? e.className += ' fadein' : null, 0)}>
//                 <div className="colorbar" />
//                 <div className='message'>
//                     <h1>Welcome to HyperNote 🙌</h1>
//                     Please log in so we can save your notes!
//                     <div className='google-button' onClick={e=>auth.signIn()}>
//                         <img src={google_logo} />
//                         <div>Sign in with Google</div>
//                     </div>
//                 </div>
//             </div>
//         }

//         if(quark.core.store.notFound){
//             // <div className='google-button' onClick={e=>
//             //     quark.send('register_document', {})}>
//             //     Register
//             // </div>

//             return <div className="tachyon nag">
//                 <HeaderChrome />
//                 <div className="colorbar" />
//                 <div className='message'>
//                     <h1>Flurophore Not Found</h1>
//                 </div>
//             </div>
//         }

//         if(quark.core.store.dataDenied){
//             // show denied page
//             return <div className='tachyon nag'>
//                 <HeaderChrome />
//                 <div className="colorbar" />
//                 <div className='message'>
//                     <h1>Such Permission Much Denied</h1>
//                     <a href="/" >Take me home, mountain mama</a>
//                 </div>
//             </div>
//         }

//         // We're loading stuff from a link or signed in
//         // we might not have permission - denial could be on the way

//         if(!quark.core.store.dataLoaded){
//             return <ReactSpinner 
//                 borderTopColor="#CB5C5C"
//                 size={50} />
//         }

//         // Loaded and have permission

//         if(global.graphView) return <Graph exitGraphView={e => global.graphView = false} />;


//         let ne = num_entities()
//         const dismissUpgradeNag = e => {
//             last_upgrade_dismiss = Date.now()
//             this.setState({upgradeNagging: false})
//         }


//         return <div className='tachyon'>
//             <HeaderChrome />
//             <button className="toggleGraphView grey" onClick={e => {global.graphView = true; globalUpdate()}}>Enter Network View</button>
            
//             <div className="colorbar" />

//             {this.state.upgradeNagging
//                 ? <div className='oob-nag-wrap'
//                     ref={e => this.nagWrap = e}
//                     onClick={e => e.target == this.nagWrap && dismissUpgradeNag()}>
//                     <div className='oob-nag'>
//                         <h1>Out Of Bullets</h1>
//                         <div
//                             className='x'
//                             onClick={dismissUpgradeNag}>&times;</div>
//                         {quark.loadingFromLink
//                             ? "The owner of this HyperNote should upgrade to get more!"
//                             : <div>
//                                 You've used up your {MAX_ENTITIES} monthly bullets - consider upgrading to get unlimited bullets per month!
//                                 <div className='upgrade-button' 
//                                     onClick={e => {
//                                         quark.set_root_text(tok('Upgrade'))
//                                         dismissUpgradeNag()
//                                 }}>Join HyperNote Pro</div>
//                             </div>}
//                     </div>
//                 </div>
//                 :null}

//             <Azimuth path={[]} line={global.$$root$$} />
//             {   
//                 ne > 4/5 * MAX_ENTITIES
//                 ? <div className='getting-full-nag'>
//                     <div className='bullets-used'>
//                         <div style={{width: 100*ne/MAX_ENTITIES + '%'}}/>
//                     </div>
//                     <div onClick={e => {
//                             e.preventDefault()
//                             quark.set_root_text(tok('Upgrade'))
//                             dismissUpgradeNag()
//                         }}>
//                         You've used {ne} of {MAX_ENTITIES} monthly bullets. <a href='#' >Get more space</a>
//                     </div>
//                 </div>
//                 :null
//             }
//         </div>
//     }
// }

class Aphelion extends Component {
    constructor(){

        super()

        global.globalUpdate = () => {
            this.setState({})
        }

        // quark.core.store.createWebSocket()
    }
    render() {
        document.body.classList.toggle('dark-theme', !!localStorage.dark)

        // We're loading stuff from a link or signed in
        // we might not have permission - denial could be on the way

        if(!quark.core.store.dataLoaded){
            return <ReactSpinner 
                borderTopColor="#CB5C5C"
                size={50} />
        }

        // Loaded and have permission

        if(global.graphView) return <Graph exitGraphView={e => global.graphView = false} />;


        return <div className='tachyon'>
            
            <button className="toggleGraphView grey" onClick={e => {global.graphView = true; globalUpdate()}}>Enter Network View</button>
            
            <div className="colorbar" />


            <Azimuth path={[]} line={global.$$root$$} />
        </div>
    }
}

// global.blah = function(){
//     graphView = true;
//     globalUpdate()
// }
// document.getElementById('colorbar').addEventListener('click', function(){
//     graphView = !graphView;
//     globalUpdate()
// })
// class Setup extends Component {
//     state = {
//         signin: 'google',
//         url: '',
//         urls:{}
//     }
//     constructor(){
//         super()
//     }
//     render(){
//         return <div className='tachyon nag'>
//             <div className="colorbar" />
//             <div className='message'>
//                 <h1>Welcome to HyperNote 🙌</h1>
//                 You only have one step left!
//                 <h2>1. Sign In:</h2>
//                 {
//                     this.state.signin == 'google'
//                         ? <div>
//                             <div className='google-button' onClick={e=>{
//                                 auth
//                                 .signIn()
//                                 .then( user => {
//                                     location.href = location.origin + '/' + this.state.url
//                                 })
//                             }}>
//                                 <img src={google_logo} />
//                                 <div>Sign in to HyperNote with Google</div>
//                             </div>
//                             {null && <div onClick={e => this.setState({signin: 'email'})}>Use email</div>}
//                         </div>
//                         : <div>
//                             <div onClick={e => this.setState({signin: 'google'})}>Back</div>
//                             <input placeholder='email'/>
//                             <input type='password'/>
//                             <input type='password'/>
//                             <button>Sign In</button>
//                         </div>
//                 }
//             </div>
//         </div>
//     }
// }

// import YouTube from 'react-youtube'

// const helptopics = {
//     welcome: <div>
//         <h1>Welcome to HyperNote!</h1>
//         <YouTube
//             videoId="2g811Eo7K8U"
//             opts = {{
//                 height: '390',
//                 width: '640',
//                 playerVars: { // https://developers.google.com/youtube/player_parameters
//                     autoplay: 1
//                 }
//             }}
//         />
//     </div>,
//     merp: <div>merp</div>,
//     dep: <div>dep</div>,
//     asdfcome: <div>zam</div>,
//     elbox: <div>elbox</div>,
//     asdf: <div>elbox</div>,
//     elbosx: <div>elbox</div>,
//     elbaox: <div>elbox</div>
// }

// class Help extends Component {
//     state = {
//         hidden: true,
//         topic: 'welcome'
//     };
//     render(){
//         return <div className='help'>
//             <span onClick={e => this.setState({hidden: !this.state.hidden})}>Help</span>
//             {
//                 !this.state.hidden && <div className='help-modal'>
//                     <div className='nipple'/>
//                     <div className='x' onClick={e => this.setState({hidden: true})}>&times;</div>

//                     <div className='help-body'>
//                         <div className='help-topics'>{
//                             Object.keys(helptopics).map((topic, i) => <div 
//                                 key={i}
//                                 className='help-topic'
//                                 onClick={e => this.setState({topic})}>{topic}</div>
//                             )
//                         }</div>
//                         <div className='help-display'>{helptopics[this.state.topic]}</div>
//                     </div>                    
//                 </div>
//             }
//         </div>
//     }
// }

class NoMatch extends Component {
    render(){
        return <div>
            <h1>404</h1>
            <p>i can't believe this thing is bloated enough to have its own internal 404 handler</p>
        </div>
    }
}

ReactDOM.render(<Aphelion />, document.getElementById('root'));
// <Route path="/" component={App}>
//     <Route path="about" component={About}/>
//     <Route path="users" component={Users}>
//     <Route path="/user/:userId" component={User}/>
//     </Route>
// ReactDOM.render(
// <Router>
//     <Route path="/" component={Aphelion}/>
//     <Route path="*" component={NoMatch} />
// </Router>
// , document.getElementById('root'))


// WEBPACK FOOTER //
// ./src/Aphelion.jsx